import script from "./CertificateDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificateDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CertificateDialog.vue?vue&type=style&index=0&id=6dd62bf0&lang=scss"

const __exports__ = script;

export default __exports__